/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BroadcastScheduleDto } from '../../models/broadcast-schedule-dto';

export interface BroadcastScheduleControllerFindByIdV1$Params {
  id: string;
}

export function broadcastScheduleControllerFindByIdV1(http: HttpClient, rootUrl: string, params: BroadcastScheduleControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BroadcastScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, broadcastScheduleControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BroadcastScheduleDto>;
    })
  );
}

broadcastScheduleControllerFindByIdV1.PATH = '/api/v1/broadcast-schedule/{id}';
